import React, { useState } from 'react';
import PredefinedReports from './PredefinedReports';
import CustomReportBuilder from './CustomReportBuilder';

const ManagementStateTab: React.FC = () => {
  const [activeSubTab, setActiveSubTab] = useState<'predefined' | 'custom'>('predefined');

  return (
    <div className="p-6">
      {/* En-tête */}
      <div className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900">État de Gestion</h2>
        <p className="text-sm text-gray-600 mt-1">
          Consultez les rapports prédéfinis ou créez vos propres analyses personnalisées
        </p>
      </div>

      {/* Navigation des sous-onglets */}
      <div className="mb-6">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex space-x-8">
            <button
              onClick={() => setActiveSubTab('predefined')}
              className={`py-2 px-1 border-b-2 font-medium text-sm ${
                activeSubTab === 'predefined'
                  ? 'border-green-500 text-green-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <i className="fas fa-list-alt mr-2"></i>
              Rapports Prédéfinis
            </button>
            <button
              onClick={() => setActiveSubTab('custom')}
              className={`py-2 px-1 border-b-2 font-medium text-sm ${
                activeSubTab === 'custom'
                  ? 'border-green-500 text-green-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <i className="fas fa-tools mr-2"></i>
              Créateur de Rapports
            </button>
          </nav>
        </div>
      </div>

      {/* Contenu des sous-onglets */}
      <div>
        {activeSubTab === 'predefined' && <PredefinedReports />}
        {activeSubTab === 'custom' && <CustomReportBuilder />}
      </div>
    </div>
  );
};

export default ManagementStateTab;
